import { render, staticRenderFns } from "./PaymentStateFailed.vue?vue&type=template&id=742cd4ee&scoped=true&"
import script from "./PaymentStateFailed.vue?vue&type=script&lang=js&"
export * from "./PaymentStateFailed.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStateFailed.vue?vue&type=style&index=0&id=742cd4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742cd4ee",
  null
  
)

export default component.exports